var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('v-main',[(this.$route.path !== '/')?_c('Toolbar',{attrs:{"menu-atual":this.menuAtual}}):_vm._e(),_c('router-view'),_c('Notify'),_c('Loader')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }